export default __webpack_public_path__ + "static/media/hall-of-fame-icon-audius.d52a3c3c.svg";